import { FICHAS_NO_VALUE } from "@/screens/financeiro/obras/fichas/ficha-formatacao/ficha-formatacao";

export const SEM_VALOR = FICHAS_NO_VALUE;

/** Exportar e E-mail são a HU 2689. */
export const EMAIL_LABEL = "Enviar e-mail para controladoria";
export const EXPORTAR_LABEL = "Exportar";

export const ANEXOS_ADICIONAR = "Adicionar Arquivo";
export const ANEXOS_VAZIO_TITULO = "Nenhum arquivo anexado.";
/** Na prévia ainda não há ficha salva para receber anexos (a inclusão é da HU 2688). */
export const ANEXOS_SALVAR_ANTES = "Salve a ficha para anexar arquivos.";

export const ORCAMENTO_EM_BREVE_TITULO = "Estamos trabalhando na implementação desta seção.";
export const ORCAMENTO_EM_BREVE_DESCRICAO =
  "Em breve o Orçamento por Coletor estará disponível aqui.";
